(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  /*
   * Take turns, and remember a dismissal.
   *
   * The rotation is skipped outright when the visitor has asked for reduced
   * motion, and when there is only one message — in both cases the markup
   * already shows the right thing, so there is nothing to do.
   */
  (function () {
    const bar = document.querySelector('[data-announcement]');
    if (!bar) return;

    const close = bar.querySelector('[data-announcement-close]');
    if (close) {
      close.addEventListener('click', () => {
        bar.hidden = true;
        try {
          localStorage.setItem(bar.dataset.storageKey, 'dismissed');
        } catch (error) {
          /* A dismissal that cannot be stored still applies to this page. */
        }
      });
    }

    const messages = [...bar.querySelectorAll('[data-message]')];
    if (messages.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const seconds = parseFloat(getComputedStyle(bar).getPropertyValue('--rotate-after')) || 6;
    let index = 0;
    let held = false;

    /* Hold while it is being read, or while the tab is in the background. */
    const hold = (on) => {
      held = on;
      bar.classList.toggle('is-held', on);
    };
    bar.addEventListener('pointerenter', () => hold(true));
    bar.addEventListener('pointerleave', () => hold(false));
    bar.addEventListener('focusin', () => hold(true));
    bar.addEventListener('focusout', () => hold(false));
    document.addEventListener('visibilitychange', () => hold(document.hidden));

    setInterval(() => {
      if (held) return;
      messages[index].classList.remove('is-current');
      index = (index + 1) % messages.length;
      messages[index].classList.add('is-current');
    }, seconds * 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class ShopMenu {
    constructor(header) {
      this.toggle = header.querySelector('.shop-header__menu-toggle');
      this.panel = document.getElementById('shop-menu');

      if (!this.toggle || !this.panel) return;

      this.toggle.addEventListener('click', () => this.setOpen(this.panel.hidden));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !this.panel.hidden) this.setOpen(false);
      });

      /* A tap on a link inside the panel should close it on the way out. */
      this.panel.addEventListener('click', (event) => {
        if (event.target.closest('a')) this.setOpen(false);
      });
    }

    setOpen(open) {
      this.panel.hidden = !open;
      this.toggle.setAttribute('aria-expanded', String(open));
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }
  }

  document.querySelectorAll('.shop-header').forEach((header) => new ShopMenu(header));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  /*
   * Start the hero film, but only when it is welcome.
   *
   * Three gates, all of which must pass:
   *   - the visitor has not asked for reduced motion
   *   - the connection is not flagged as metered or slow
   *   - the hero is actually on screen
   *
   * Fail any of them and the poster frame simply stays, which is a real
   * photograph of the same arrangement rather than a blank box. The same is
   * true if this script never runs: there is no autoplay attribute, so the
   * markup on its own is a poster and nothing more.
   */
  (function () {
    const film = document.querySelector('[data-hero-video]');
    if (!film) return;

    const still = window.matchMedia('(prefers-reduced-motion: reduce)');

    function metered() {
      const net = navigator.connection;
      if (!net) return false;
      if (net.saveData) return true;
      return ['slow-2g', '2g'].includes(net.effectiveType);
    }

    function stop() {
      film.pause();
      film.removeAttribute('autoplay');
    }

    function play() {
      if (still.matches || metered()) return;
      /* preload="none" means nothing is fetched until this point. */
      film.preload = 'auto';
      const started = film.play();
      if (started && started.catch) {
        /* A refused autoplay is not an error worth surfacing — the poster stays. */
        started.catch(() => {});
      }
    }

    /* Do not spend a phone's data on a film that has already scrolled away. */
    const watcher = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => (entry.isIntersecting ? play() : film.pause()));
      },
      { threshold: 0.1 }
    );
    watcher.observe(film);

    still.addEventListener('change', () => (still.matches ? stop() : play()));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  /*
   * Buy panel behaviour.
   *
   * Three jobs: keep the selected card and the button total in step, add
   * both lines in one request, and show the gallery's position on a phone.
   * Every total is pre-formatted in Liquid and read off the chosen radio,
   * so this file never does currency arithmetic.
   */
  class ProductPanel {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('form[action*="/cart/add"]');
      this.addon = root.querySelector('[data-addon]');
      this.label = root.querySelector('[data-submit-label]');
      this.submit = root.querySelector('[data-submit]');
      this.error = root.querySelector('[data-error]');
      this.sticky = document.querySelector('[data-sticky]');
      this.stickyTotal = document.querySelector('[data-sticky-total]');

      if (!this.form) return;

      this.root.addEventListener('change', (event) => {
        if (event.target.matches('[data-variant], [data-addon]')) this.sync();
      });

      this.form.addEventListener('submit', (event) => this.onSubmit(event));

      this.watchGallery();
      this.watchSticky();
      this.watchRitual();
      this.sync();
    }

    get variant() {
      return this.form.querySelector('[data-variant]:checked') || this.form.querySelector('input[type="hidden"][data-variant]');
    }

    /** Move the selected ring and swap in the matching pre-formatted total. */
    sync() {
      const variant = this.variant;
      if (!variant) return;

      this.root.querySelectorAll('.ladder__card').forEach((card) => {
        card.classList.toggle('is-selected', card.contains(variant));
      });

      const on = this.addon && this.addon.checked;
      const total = on ? variant.dataset.totalOn : variant.dataset.totalOff;
      if (!total) return;

      if (this.label && this.label.dataset.template) {
        this.label.textContent = this.label.dataset.template.replace('__P__', total);
      }
      if (this.stickyTotal) this.stickyTotal.textContent = total;

      /*
       * Nothing about changing a bundle moves focus or reloads the page, so
       * without this a screen reader user taps "3 børster" and is told
       * nothing whatsoever. Skipped on the very first sync, which is just
       * the page describing its own starting state.
       */
      if (this.ready && window.announce) {
        const name = variant.closest('label');
        const label = name ? name.querySelector('.ladder__name') : null;
        window.announce([label && label.textContent.trim(), total].filter(Boolean).join(', '));
      }
      this.ready = true;
    }

    async onSubmit(event) {
      if (!window.cartDrawer) return; // No script: let the form post normally.

      event.preventDefault();

      /*
       * assets/cart-drawer.js also listens for submits on /cart/add, at the
       * document. Without this the submit is handled twice — once here with
       * the brush and its add-on, and once there with just the brush — and
       * the shopper ends up with a duplicate line. This listener is on the
       * form itself, so it runs first and stops the event before it bubbles.
       */
      event.stopPropagation();

      const variant = this.variant;
      if (!variant || !variant.value) return;

      const items = [{ id: Number(variant.value), quantity: 1 }];
      if (this.addon && this.addon.checked) {
        items.push({ id: Number(this.addon.value), quantity: 1 });
      }

      this.submit.disabled = true;
      if (this.error) this.error.hidden = true;

      try {
        await window.cartDrawer.addItems(items);
        if (window.announce && this.label) {
          window.announce(this.label.textContent.trim());
        }
      } catch (reason) {
        if (this.error) this.error.hidden = false;
      } finally {
        this.submit.disabled = false;
      }
    }

    /**
     * The gallery.
     *
     * The rail is the only state there is: whichever slide is centred in it
     * is the current one, and thumbnails, dots and arrows all read from and
     * write to that. Nothing keeps its own idea of the index, so a swipe, a
     * thumbnail click and an arrow key cannot disagree.
     */
    watchGallery() {
      const rail = this.root.querySelector('[data-gallery]');
      if (!rail) return;

      const slides = [...rail.querySelectorAll('[data-slide]')];
      const dots = [...this.root.querySelectorAll('.product__dot')];
      const thumbs = [...this.root.querySelectorAll('[data-thumb]')];
      if (slides.length < 2) return;

      let current = 0;

      const show = (index) => {
        current = Math.max(0, Math.min(slides.length - 1, index));
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === current));
        thumbs.forEach((thumb, i) => {
          thumb.classList.toggle('is-active', i === current);
          /* aria-current, not aria-selected: these are buttons, not tabs. */
          if (i === current) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
      };

      const goTo = (index) => {
        const target = Math.max(0, Math.min(slides.length - 1, index));
        rail.scrollTo({ left: slides[target].offsetLeft - rail.offsetLeft, behavior: 'smooth' });
        show(target);
      };

      /* The rail tells us where it landed, however it got there. */
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) show(slides.indexOf(entry.target));
          });
        },
        { root: rail, threshold: 0.6 }
      );
      slides.forEach((slide) => observer.observe(slide));

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => goTo(Number(thumb.dataset.thumb)));
      });

      this.root.querySelectorAll('[data-nav]').forEach((button) => {
        button.addEventListener('click', () => {
          /* Wraps, so the last image's right half returns to the first. */
          const step = Number(button.dataset.nav);
          const next = (current + step + slides.length) % slides.length;
          goTo(next);
        });
      });

      /* Arrow keys once anything inside the gallery has focus. */
      const media = this.root.querySelector('[data-gallery-root]') || rail;
      media.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        goTo(current + (event.key === 'ArrowRight' ? 1 : -1));
      });

      show(0);
    }

    watchRitual() {
      const card = this.root.querySelector('[data-ritual]');
      if (card) new RitualRing(card);
    }

    /**
     * The sticky bar appears only once the real button has scrolled away,
     * so the two are never on screen at the same time asking for the same
     * tap. It slides rather than blinking: [hidden] is dropped once, and
     * after that the class does the work, because display:none cannot
     * transition.
     */
    watchSticky() {
      if (!this.sticky || !this.submit) return;

      this.sticky.hidden = false;

      const observer = new IntersectionObserver(
        ([entry]) => {
          this.sticky.classList.toggle('is-up', !entry.isIntersecting);
        },
        { threshold: 0 }
      );

      observer.observe(this.submit);
    }
  }

  /**
   * The words drifting round the ritual card.
   *
   * The band's centre line is laid down as one path, and the phrase is
   * repeated just enough times to go round it once, stretched to fit
   * exactly. Two copies ride the path, one lap apart: as the first slides
   * off the end the second slides on at the start, so the loop has no seam
   * and no glyph is ever drawn twice. The path is rebuilt in real pixels
   * whenever the card changes size, so the corners never stretch.
   */
  class RitualRing {
    constructor(card) {
      this.card = card;
      this.svg = card.querySelector('[data-ritual-ring]');
      if (!this.svg) return;

      this.phrase = `${this.svg.dataset.ritualText}  \u2022  `;
      this.id = `ritual-${Math.random().toString(36).slice(2, 8)}`;
      this.offset = 0;
      this.length = 0;
      this.visible = false;
      this.still = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.build = this.build.bind(this);
      this.tick = this.tick.bind(this);

      new ResizeObserver(this.build).observe(card);
      new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        if (this.visible) this.start();
      }).observe(card);

      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.build);
    }

    build() {
      const ns = 'http://www.w3.org/2000/svg';
      const w = this.card.offsetWidth;
      const h = this.card.offsetHeight;
      if (!w || !h) return;

      const style = getComputedStyle(this.card);
      const band = parseFloat(style.getPropertyValue('--band')) || 24;
      const outer = parseFloat(style.borderTopLeftRadius) || 34;
      const i = band / 2;
      const r = Math.max(0, Math.min(outer - i, (h - band) / 2));

      const d = [
        `M ${i + r} ${i}`,
        `H ${w - i - r}`,
        `A ${r} ${r} 0 0 1 ${w - i} ${i + r}`,
        `V ${h - i - r}`,
        `A ${r} ${r} 0 0 1 ${w - i - r} ${h - i}`,
        `H ${i + r}`,
        `A ${r} ${r} 0 0 1 ${i} ${h - i - r}`,
        `V ${i + r}`,
        `A ${r} ${r} 0 0 1 ${i + r} ${i}`,
        'Z',
      ].join(' ');

      this.svg.setAttribute('viewBox', `0 0 ${w} ${h}`);
      this.svg.replaceChildren();

      const path = document.createElementNS(ns, 'path');
      path.setAttribute('id', this.id);
      path.setAttribute('d', d);
      path.setAttribute('fill', 'none');
      this.svg.append(path);

      /* Measure one phrase in the real font before deciding how many fit. */
      const probe = document.createElementNS(ns, 'text');
      probe.textContent = this.phrase;
      this.svg.append(probe);
      const unit = probe.getComputedTextLength() || 80;
      probe.remove();

      this.length = path.getTotalLength();
      const count = Math.max(1, Math.round(this.length / unit));
      const words = this.phrase.repeat(count);

      this.copies = [0, 1].map(() => {
        const text = document.createElementNS(ns, 'text');
        text.setAttribute('dominant-baseline', 'central');
        text.setAttribute('textLength', this.length);
        text.setAttribute('lengthAdjust', 'spacing');
        const along = document.createElementNS(ns, 'textPath');
        along.setAttribute('href', `#${this.id}`);
        along.textContent = words;
        text.append(along);
        this.svg.append(text);
        return along;
      });

      this.offset %= this.length;
      this.place();
      this.start();
    }

    place() {
      if (!this.copies) return;
      this.copies[0].setAttribute('startOffset', this.offset);
      this.copies[1].setAttribute('startOffset', this.offset - this.length);
    }

    start() {
      if (this.running || this.still.matches || !this.visible || !this.length) return;
      this.running = true;
      this.last = performance.now();
      requestAnimationFrame(this.tick);
    }

    tick(now) {
      if (!this.visible || this.still.matches) {
        this.running = false;
        return;
      }
      /* About 28px a second: slow enough to read while it moves. */
      this.offset = (this.offset + ((now - this.last) / 1000) * 28) % this.length;
      this.last = now;
      this.place();
      requestAnimationFrame(this.tick);
    }
  }

  document.querySelectorAll('[data-product-root]').forEach((root) => new ProductPanel(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  /*
   * Unfold the rest of the reviews.
   *
   * The button removes a class and then removes itself. Focus moves to the
   * first review that was revealed, so a keyboard or screen-reader user is
   * put where the new content is rather than left on a button that has just
   * disappeared from under them.
   */
  document.querySelectorAll('[data-reviews-more]').forEach((button) => {
    button.addEventListener('click', () => {
      const list = button.parentElement.querySelector('[data-reviews]');
      if (!list) return;

      const folded = [...list.querySelectorAll('.review.is-folded')];
      folded.forEach((review) => review.classList.remove('is-folded'));

      if (folded.length) {
        folded[0].setAttribute('tabindex', '-1');
        folded[0].focus({ preventScroll: true });
      }
      button.remove();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-rail"] && !Shopify.designMode) return;
  try {
    
  /*
   * Three jobs the browser will not do on its own.
   */
  (function () {
    const clips = [...document.querySelectorAll('[data-clip]')];
    if (!clips.length) return;

    /* 1. One at a time. Two talking heads at once is nobody's idea of trust. */
    clips.forEach((clip) => {
      clip.addEventListener('play', () => {
        clips.forEach((other) => {
          if (other !== clip && !other.paused) other.pause();
        });
      });
    });

    /* 2. Scrolled away means paused — and on a phone, means stop spending data. */
    const watcher = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting && !entry.target.paused) entry.target.pause();
        });
      },
      { threshold: 0.25 }
    );
    clips.forEach((clip) => watcher.observe(clip));

    /*
     * 3. Reduced motion. Nothing here starts by itself, so there is nothing
     * to switch off — but if a clip is already running when the preference
     * is turned on, honour it immediately rather than at the next reload.
     */
    const still = window.matchMedia('(prefers-reduced-motion: reduce)');
    still.addEventListener('change', () => {
      if (still.matches) clips.forEach((clip) => clip.pause());
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
